import { FaceScanAnimationProps } from "../../../types/interfaces";

export default function FaceScanAnimation({
  faceZoomed,
  showFaceScanLine,
  faceScanLinePosition,
  faceScanVideo,
}: FaceScanAnimationProps) {
  return (
    <div className="relative h-full w-full common-ui-main">
      <div className="w-full h-full relative">
        <video
          className="h-full w-full object-contain border-none"
          muted
          autoPlay
          playsInline
        >
          <source src={faceScanVideo} type="video/mp4" />
        </video>
        {showFaceScanLine && faceZoomed && (
          <div
            className="absolute w-[1px] bg-[#8B5CF6] shadow-[0_0_8px_rgba(139,92,246,0.8)] z-20"
            style={{
              left: `${faceScanLinePosition}%`,
              top: "0%",
              height: "40%",
              opacity:
                faceScanLinePosition && faceScanLinePosition >= 0 ? 1 : 0,
            }}
          />
        )}
      </div>
    </div>
  );
}
